<template>
	<div class="funnel-orders-page main-content no-padding noscroll">

<!--		<Loading v-show="loading"/>-->

		<div class="funnel_apps layout-column noscroll">
			<div class="funnel_apps_header">
				<h3>Orders
					<span class="panel_head_amount" v-if="ordersMeta.count">
                        <span v-if="currentPage !== ordersMeta.total_pages">
                            {{ currentPage === 1 ? 1 : (currentPage * ordersMeta.per_page) - ordersMeta.per_page }} -
                            {{ (currentPage) * ordersMeta.per_page }} from {{ ordersMeta.count }}
                        </span>
                        <span v-else>
                            {{ ordersMeta.count - ordersMeta.per_page }} - {{ ordersMeta.count
	                        }} from {{ ordersMeta.count }}
                        </span>
                    </span>
				</h3>
				<div class="flex"></div>
				<div class="layout-row">
					<v-button flat class="small-btn reload-btn" :class="{'loading':loading}" @click="loadOrders()"
					          :icon="require('@/assets/img/reload.svg')" />

					<v-button @click="exportOrdersOpen = true" border :disabled="!ordersMeta.count"
					          label="Export orders"/>
				</div>
			</div>
			<div class=" scroll">
				<div class="orders-page-content">
					<div class="search-container">
						<input type="text" placeholder="Type to search..." class="search-input" v-model="searchValue"
						       @input="searchValueChanged">
						<v-spinner v-if="loading" />

					</div>

					<div class="entries-table">
						<div class="head " v-if="ordersMeta.count">
<!--							<span class="cell number">#</span>-->
							<span class="cell time">Time
							<inline-svg class="arrow" :src="require('@/assets/img/arrow-top.svg')" />
							</span>
							<span class="cell status">Status</span>
							<span class="cell customer">Customer</span>
							<span class="cell product">Product</span>
							<span class="cell amount">Amount</span>
							<span class="cell actions"></span>
						</div>
						<div class="panel-body" v-if="ordersMeta.count">
							<order-item :order="item" v-for="(item,index) in orders" :key="item.id" />
						</div>
						<div v-if="!ifError && !ordersMeta.count" class="panel-body panel-body_2 empty-panel">
							<p>No orders have been found</p>
						</div>
					</div>
					<paginate
							v-if="!ifError && ordersMeta.count"
							:pageCount="ordersMeta.total_pages"
							:pageRange="7"
							:forcePage="currentPage"
							:clickHandler="clickCallback"
							:prevText="'<<'"
							:nextText="'>>'"
							:containerClass="'pagination pagination-root'"
							:activeClass="'active'"
					>
					</paginate>
				</div>
			</div>
		</div>
		<!-- ORDER DETAILS -->
<!--		<router-view/>-->

<!--		<popup-backdrop v-if="currentOrderId" @close="currentOrderId=null">-->
<!--			<order-details-new :orderId="currentOrderId" @close="currentOrderId=null" />-->
<!--		</popup-backdrop>-->

		<ExportOrders v-if="exportOrdersOpen" :funnel="funnel" @closeExportPopup="exportOrdersOpen = false"/>
	</div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";
import ExportOrders from "@/components/popups/orders/ExportOrders.vue";
import Loading from "@/components/Loading.vue"
import {mapGetters} from "vuex"
import API from "@/api"

import HelpBlock from "@/components/base/help-block";
import VButton from "@/components/base/v-button";
import {getSourceLogo} from "@/helpers/gateways";
import {getSymbol} from "@/helpers/currencies";
import VSpinner from "@/components/base/v-spinner";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import OrderItem from "@/views/orders/order-item";

export default {
	name: "FunnelOrders",
	components: {
		OrderItem,
		QuickActionsBtn,
		VSpinner,
		VButton,
		HelpBlock,
		MainSearch,
		Loading,
		ExportOrders
	},
	mixins: [API],
	props: ['id'],
	data() {
		return {
			currentOrderId: null,
			searchValue: "",
			loading: true,
			searchInput: '',
			funnel: {},
			stepData: [],
			// orders: [],
			customer: {},
			currentOrder: {},
			page: 0,
			perPage: 25,
			query: '',
			ordersLinks: [
				{
					id: 1,
					title: "Learn more about orders.",
					url: "https://docs.funnelish.com/getting-started/connecting-funnels/orders"
				},
				{
					id: 2,
					title: "Learn more about tracking Clickfunnels sales within Funnelish.",
					url: "https://docs.funnelish.com/getting-started/connecting-funnels"
				}
			],
			ordersMeta: {
				count: 0,
				per_page: 0,
				total_pages: 0
			},
			orderPages: [],
			notifocation: true,
			exportOrdersOpen: false,
			ordersByType: 'all',
			startDate: "2020-12-02",
			endDate: "2020-12-02",
		}
	},
	computed: {
		...mapGetters(["getOrderInfoPopup", "ifError", "getOrdersStore", "getFunnelStore", "getOrdersMetaStore", "getOrdersPageStore"]),
		ordersFilteredList() {
			return this.orders.filter(item => {
				return item.attributes['first-name'].toLowerCase().includes(this.searchInput.toLowerCase())
			})
		},
		currentPage() {
			var page = this.$route.query.page
			return page ? parseInt(page) : 1
		},
		orders(){
			return this.getOrdersStore;
		}
	},
	methods: {
		currency(c) {
			return getSymbol(c);
		},
		getImage(appId, gatewayId) {
			return getSourceLogo(appId, gatewayId)
		},
		searchValueChanged() {
			// Reset current page before query to start from first page.
			this.$router.push({path: this.$router.path, query: {page: 1, query: this.searchValue}});
			this.loadOrders();
		},
		clickCallback(pageNum) {
			this.$router.push({path: this.$router.path, query: {page: pageNum, query: this.searchValue}});
			this.loadOrders();
		},
		dayCompile(val) {
			if (parseInt(val) < 10) {
				return '0' + val
			} else {
				return val
			}
		},
		initPagination(size) {
			if (this.orderPages.length === 0) {
				var index = 0;
				while (index < size) {
					this.orderPages.push(index);
					index++
				}
			}
		},
		async loadOrders() {
			try {
				this.loading = true;
				this.funnel = this.getFunnelStore;
				let {
					orders,
					meta
				} = await this.api.orders.getFunnel(this.id, this.currentPage - 1, this.perPage, this.searchValue);
				// this.$store.dispatch("setOrders", orders);
				// this.orders = orders;
				this.ordersMeta = meta;

				this.$store.dispatch('setOrdersStore', orders);
				this.$store.dispatch('setOrdersMetaStore', this.ordersMeta);
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		},
		async init() {
			this.loadOrders()
		}
	},
	async mounted() {
		this.init();
	}
}
</script>

<style lang="scss" scoped>
.orders-page-content {
	padding: 60px 40px 80px;
	max-width: 2000px;
	margin: 0 auto;
}
.funnel-orders-page {
	.search-container {
		position: relative;
		margin-bottom: 40px;
	}
}


</style>
